import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { CarrierDriverDetailsComponent } from './carrier-driver-details.component';
import { BusyModule } from 'app/busy/busy.module';
import { CarrierTypeModule } from 'app/shared/carrier-type/carrier-type.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FileDropModule } from 'ngx-file-drop';
import { NgxLoadingModule } from 'ngx-loading';


@NgModule({
  declarations: [
    CarrierDriverDetailsComponent
  ],
  imports: [
    CommonModule,
    CarrierTypeModule,
    NgxLoadingModule.forRoot({}),
    PdfViewerModule,
    FileDropModule,
  ],
  exports: [CarrierDriverDetailsComponent]
})
export class CarrierDriverDetailsModule { }
